import { type ResourcesConfig } from 'aws-amplify'

import { environment } from '../environments/environment'

const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: environment.COGNITO_USER_POOL_ID,
      userPoolClientId: environment.COGNITO_USER_POOL_WEBCLIENT_ID,
      loginWith: {
        email: true,
      },
    },
  },
}
export default amplifyConfig
